import { render, staticRenderFns } from "./StudentDocumentListDialog.vue?vue&type=template&id=5f970c07&"
import script from "./StudentDocumentListDialog.vue?vue&type=script&lang=ts&"
export * from "./StudentDocumentListDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports